import {Visibility} from 'common/components/base/stackable';

export type ModalChangeEvent = CustomEvent<{state: Visibility}>;

export enum ModalType {
  Popup = `popup`,
  Modal = `modal`,
  RightDrawer = `right-drawer`,
  RightDrawerUnderHeader = `right-drawer-under-header`,
  BottomDrawer = `bottom-drawer`,
  TourModal = `tour-modal`,
}

export enum VerticalAlignment {
  Top = `top`,
  Center = `center`,
  Bottom = `bottom`,
}

/** Panel-style (kebab-case) attributes, consumed by `<ModalEl>` callsites and `confirm`. */
export interface ModalAttrs {
  closeable?: boolean;
  'grow-to-content'?: boolean;
  'hide-backdrop'?: boolean;
  'hide-background'?: boolean;
  'hide-close-button'?: boolean;
  'modal-type'?: ModalType;
  'modal-title'?: string;
  'modal-description'?: string;
  'not-fullscreen'?: boolean;
  open: boolean;
  'vertical-alignment'?: VerticalAlignment;
  'close-confirm-text'?: string;
  'sliding-transition'?: boolean;
  'close-button-padded'?: boolean;
  /** Setting this to true prevents this modal from interacting with the stacking context. */
  'ignore-stacking'?: boolean;
  /** Setting this to true only closes previously-opened modals of the same type. */
  'close-of-same-type'?: boolean;
}

/** Imperative handle exposed via `ref`. */
export interface ModalHandle {
  close: () => void;
}

export enum ExportDashboardModalPage {
  Main = `main`,
  ConfirmExternalUsers = `confirm-external-users`,
}
